"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const RawLink = styled_components_1.default.a(({ theme }) => theme.link.primary);
const Link = react_1.default.forwardRef((props, ref) => {
    const { href, icon, children, testId } = props, otherProps = __rest(props, ["href", "icon", "children", "testId"]);
    return (react_1.default.createElement(RawLink, Object.assign({ "data-id": testId, href: href }, otherProps, { ref: ref }),
        react_1.default.createElement(react_1.default.Fragment, null,
            icon ? react_1.default.createElement(components_common_icon_1.Icon, { name: icon.name }) : null,
            children)));
});
if (process.env.NODE_ENV === 'development') {
    Link.displayName = 'Link';
}
exports.default = Link;
//# sourceMappingURL=Link.js.map